module.exports = __webpack_public_path__ + "img/mainImg.5f7ef9ee.png";